import { useMedia } from 'react-use';

import { isTokenBlockedByTokenList } from '@/utils/0x/token-blocking';
import { isZoraCreatorCoin, isZoraToken, type ZoraType } from '@/utils/zora';

import { breakpoints } from '../../../../styles/util';
import type { TokenResult } from '../../../../utils/0x/token-registry.types';
import { DiscoveryTokenResult } from '../../../../utils/discovery/types';
import { ScoreTooltip } from '../../../TokenProfile/TokenLiquidityScore/ScoreTooltip';
import { LiquidityScoreInline } from './LiquidityScoreInline';

function LiquidityScore({
  item,
  score,
  scoreLoading,
  skipBlockedTokenCheck,
  tokenResult,
}: {
  item: DiscoveryTokenResult;
  score: number | undefined;
  scoreLoading: boolean;
  skipBlockedTokenCheck?: boolean;
  tokenResult?: TokenResult;
}) {
  const visibleScore =
    skipBlockedTokenCheck || !isTokenBlockedByTokenList(tokenResult) ? score : undefined;
  const isMobile = useMedia(breakpoints.mobile, false);

  if (!item || !item.token) {
    return null;
  }

  let zoraType: ZoraType;

  if (!skipBlockedTokenCheck && isZoraToken(tokenResult)) {
    zoraType = isZoraCreatorCoin(tokenResult) ? 'creator' : 'post';
  }

  return (
    <ScoreTooltip isMobile={isMobile} currentScore={visibleScore} zoraType={zoraType}>
      <LiquidityScoreInline score={visibleScore} isLoading={scoreLoading} />
    </ScoreTooltip>
  );
}

function LiquidityScoreSkeleton() {
  return <LiquidityScoreInline score={undefined} isLoading={true} />;
}

export function LiquidityScoreCell({
  item,
  score,
  scoreLoading,
  skipBlockedTokenCheck,
  tokenResult,
}: {
  item: DiscoveryTokenResult;
  score: number | undefined;
  scoreLoading: boolean;
  skipBlockedTokenCheck?: boolean;
  tokenResult?: TokenResult;
}) {
  if (scoreLoading) {
    return <LiquidityScoreSkeleton />;
  }

  return (
    <LiquidityScore
      item={item}
      score={score}
      scoreLoading={scoreLoading}
      skipBlockedTokenCheck={skipBlockedTokenCheck}
      tokenResult={tokenResult}
    />
  );
}
